<template>
    <div>
        <navbar-component></navbar-component>
        <main>
            <page-header title="Library" :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Downloads'}]"></page-header>
            <div class="container-2">
                <section class="sidebar">
                    <sidebar :active="11"></sidebar>
                </section>
                <section class="content">
                    <div class="flex heading-black1 justify-center uppercase font-serif">downloads</div>
                    <div>
                        <DataTable :value="downloads" :rowHover="true">
                            <Column field="no" header="#"></Column>
                            <Column field="name" header="Document/Form"></Column>
                            <Column field="download" header="Download">
                                <template #body="slotProps">
                                    <a :href="slotProps.data.download" target="_blank"><i class="fas fa-download"></i></a>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </section>
            </div>
            <programmes></programmes>
        </main>
        <footer-component></footer-component>
    </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    name: "Downloads",
    components: {
        Programmes,
        NavbarComponent,
        PageHeader,
        Sidebar,
        FooterComponent,
        DataTable,
        Column,
    },
    setup() {
        const carouselSlides = ["bg-1", "bg-2", "bg-3"];
        return { carouselSlides };
    },
    data() {
        return {
            downloads: [{
                    no: 1,
                    name: 'Book Requisition Form',
                    download: '/static/pdf/library/downloads/form1.pdf',
                },
                {
                    no: 2,
                    name: 'Journal Requisition Form',
                    download: '/static/pdf/library/downloads/form2.pdf',
                },
                {
                    no: 3,
                    name: 'Book Donation Form',
                    download: '',
                },
                {
                    no: 4,
                    name: 'Identity Card Form',
                    download: '',
                },
            ]
        }
    },
}
</script>
<style lang="scss" scoped>
p {
    margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
    .p-datatable-header {
        background: #e6e6e6;
        color: #404040;
    }

    .p-datatable-thead>tr>th {
        background: #e6e6e6;
        color: #404040;
    }
}
</style>